import React from 'react';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

type OptionValueType = 'all' | 'public' | 'private';

const LeftSideFirstSection = () => {
  const t = useTranslations();

  const [query, setQuery] = useQueryParams({
    type: withDefault(StringParam, 'all'),
    page: NumberParam
  });

  const options = [
    { value: 'all', label: t('barchasi') },
    { value: 'public', label: t('davlat') },
    { value: 'private', label: t('xususiy') }
  ];

  const handleChange = (value: OptionValueType) => () => {
    setQuery({
      type: value === 'all' ? undefined : value,
      page: undefined
    });
  };

  return (
    <div className="rounded-2xl bg-white p-4 shadow-sm sm:col-span-1">
      <h3 className="text-xs text-gray-400">{t('Oliy_talim')}</h3>
      <div className="mt-1 divide-y-1 divide-gray-100">
        {options.map(item => {
          const isSelected = query?.type === item.value;

          return (
            <div
              key={item?.value}
              onClick={handleChange(item?.value as OptionValueType)}
              className="flex cursor-pointer items-center space-x-2 transition duration-200 py-3"
            >
              <div
                className={classNames("flex h-4.5 w-4.5 items-center justify-center rounded-full border-2", {
                  "border-green-500": isSelected,
                  "border-gray-300": !isSelected
                })}
              >
                {isSelected && <div className="h-2.5 w-2.5 rounded-full bg-green-500" />}
              </div>
              <span className="text-sm">{item?.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeftSideFirstSection;
